import Wire from '../../../components/vehicle/wire'
import WireStore from '../../../components/vehicle/wire/context/context'

const WirePage = () => {
  return (
    <WireStore>
      <Wire />
    </WireStore>
  )
}

export default WirePage
